import React from 'react';
import { Container } from './styles';

import { IconLoader } from '@tabler/icons';

interface ButtonProps {
  isLoading?: boolean;
  [x: string]: any;
}

const Button: React.FC<ButtonProps> = ({ children, isLoading, ...rest }) => {
  return (
    <Container loading={isLoading} {...rest}>
      {isLoading ? <IconLoader size={24} className="spin" /> : children}
    </Container>
  );
};

export default Button;
